import { IAjaxConfig } from '../helpers';
/**
 *  订单 API 地址
 *  @swagger http://bpportalordersit.earth.xpaas.lenovo.com/swagger-ui.html#/
 */
export class EnumApiOrders {
  /**
   * @dec 加入购车车
   */
  readonly orders_cart_add: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/cart/add',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 删除购车
   */
  readonly orders_cart_delete: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/cart/delete',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 购车 数据变更
   */
  readonly orders_cart_change: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/cart/changeCount',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 购车 列表
   */
  readonly orders_cart: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/cart/getCartProductList',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 创建订单
   */
  readonly orders_create: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/createorder/create',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 订单列表
   */
  readonly orders_list: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerorder/order/search',
    method: 'post',
  };

  /**
   * @dec 订单详情 获取商品详情 状态1和5的
   */
  readonly orders_alldetails: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerorder/order/allDetail',
    method: 'post',
  };

  /**
   * @dec 订单详情-获取商品详情 状态1和5除外的其他
   */
  readonly orders_details: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerorder/order/detail',
    method: 'post',
  };

  /**
   * @dec 订单：取消订单
   */
  readonly order_cancel: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerorder/order/cancelOrder',
    loading: true,
    method: 'post',
  };

  /**
   * @dec 订单：提交付款信息
   */
  readonly order_submitpayinfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/bp-order-payment/submit',
    loading: true,
    method: 'post',
  };

  /**
   * @dec 订单：获取付款信息
   */
  readonly order_getpayinfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/bp-order-payment/{orderNumber}',
    loading: true,
  };

  /**
   * @dec 订单：获取收款信息
   */
  readonly order_getcollectioninfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/provider/getPaymentInfo?code={code}',
    loading: true,
  };

  /**
   * @dec 上传支付凭证图片
   */
  readonly order_pay_upload_img: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/file/upload-file?type=1',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 订单详情：订单通过
   */
  readonly order_adopt: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerorder/order/adoptOrder',
    method: 'post',
  };

  /**
   * @dec 我的订单 查看物流信息接口
   */
  readonly order_getstockinfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/tireOnedelivergood/getstockinfo/{orderNumber}',
    loading: true,
  };

  /**
   * @dec 下单成功页 获取当前订单状态信息
   */
  readonly order_getSingleOrderPollingResult: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/createorder/querySingleOrderPollingResult',
    method: 'post',
  };

  /**
   * @dec 购物车页 验证活动库存
   */
  readonly car_verifyActive: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/createorder/check',
    method: 'post',
  };

  /**
   * @dec 我的订单 获取当前账号下处理中的订单状态信息
   */
  readonly order_getAllOrderPollingResult: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/createorder/queryAllOrderPollingResult',
  };

  /**
   * @dec 我的订单 删除失败订单提示
   */
  readonly order_clearOrderFailed: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/createorder/clearOrderFailed',
    method: 'post',
  };

  /**
   * @dec 积分兑换-验证积分
   */
  readonly order_scoreVerify: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/integralShop/checkPointsIsSufficient',
    method: 'post',
  };

  /**
   * @dec 积分兑换-积分下单
   */
  readonly order_scoreSubmit: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/integralShop/createOrder',
    method: 'post',
  };
  /**
   * @dec 积分兑换-验证账号积分下单权限
   */
  readonly order_scoreCheckActivation: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/t2/checkActivation',
    method: 'post',
  };
  /**
   * @dec 积分兑换-验证账号积分ISG
   */
  readonly order_scoreCheckActivationISG: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/integral/checkISGIntegral',
    method: 'post',
  };
  /**
   * @dec ISG积分兑换
   */
  readonly order_scoreSubmitISG: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/integral/createIntegralOrderByISG',
    method: 'post',
  };
  /**
   * @dec 获取门店列表
   */
  readonly order_getShopList: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/v1/bp-order-api/t2/store-list',
    cache: true,
  };

  /**
   * @dec 我的订单 查看可收货列表
   */
  readonly order_getConfirmReceiptList: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerorder/signDeliveryList?orderId=',
    loading: true,
  };

  /**
   * @dec 我的订单 确认收货
   */
  readonly order_confirmReceipt: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerorder/signForDelivery',
    loading: true,
    method: 'post',
  };
}
